import { useState, useRef, useEffect } from 'react';

import {
  SelectBox,
  SelectedValue,
  OptionList,
  OptionItem,
  IconArrowDown,
  IconCheck,
  Values,
  OptionText,
} from './CustomSelect1.styled';

const CustomSelect1 = ({
  pad = '8px 16px',
  options,
  selectedValue,
  onChange,
  width = '240px',
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const toggleOpen = () => {
    if (disabled) return;

    setIsOpen(prev => !prev);
  };

  const handleOptionClick = value => {
    if (disabled) return;

    onChange(value);
    setIsOpen(false);
  };

  const isSelectedInvalid = !options.includes(selectedValue);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Якщо компонент став disabled, примусово закриваємо список
  useEffect(() => {
    if (disabled) {
      setIsOpen(false);
    }
  }, [disabled]);

  return (
    <SelectBox ref={selectRef}>
      <SelectedValue
        width={width}
        pad={pad}
        className={isOpen ? 'openselect' : ''}
        onClick={toggleOpen}
        color={isSelectedInvalid ? 'true' : ''}
        disabled={disabled}
      >
        <Values>{selectedValue}</Values>

        {!disabled && (
          <IconArrowDown
            isopen={isOpen ? 'true' : ''}
          />
        )}
      </SelectedValue>

      {isOpen && !disabled && (
        <OptionList>
          {options.map((option, index) => (
            <OptionItem
              key={index + 1}
              onClick={() => handleOptionClick(option)}
            >
              <OptionText>{option}</OptionText>

              {selectedValue === option && (
                <IconCheck />
              )}
            </OptionItem>
          ))}
        </OptionList>
      )}
    </SelectBox>
  );
};

export default CustomSelect1;